import apiClient from '../../../shared/config/axios'
import { TechnicianProfile } from '@myapp/contract'

export const technicianProfileApi = {
  /** Active profiles only — the API filters with `onlyActive: true`. */
  list: () => apiClient.get<TechnicianProfile[]>('/technician-profiles'),
}
